import { cn } from "@utils/index";

function Divider({ message, className }: { message?: string; className?: string }) {
  if (!message) return <hr className={cn("w-full", className)} />;
  return (
    <div className={cn("flex w-full items-center gap-4", className)}>
      <hr className="w-full flex-1" />
      <p className="pointer-events-none select-none text-xs text-gray-400 dark:text-gray-500">
        {message}
      </p>
      <hr className="w-full flex-1" />
    </div>
  );
}

export function VerticalDivider({ message }: { message?: string }) {
  if (!message)
    return (
      <div className="h-full border-l border-gray-400 dark:border-gray-500" />
    );
  return (
    <div className="flex h-full flex-col items-center gap-1">
      <div className="h-full flex-1 border-l border-gray-400 dark:border-gray-500" />
      <p className="pointer-events-none select-none text-xs text-gray-400 dark:text-gray-500">
        {message}
      </p>
      <div className="h-full flex-1 border-l border-gray-400 dark:border-gray-500" />
    </div>
  );
}

export default Divider;
